import { render, staticRenderFns } from "./theatreDetail.vue?vue&type=template&id=60dde580&scoped=true&"
import script from "./theatreDetail.vue?vue&type=script&lang=js&"
export * from "./theatreDetail.vue?vue&type=script&lang=js&"
import style0 from "./theatreDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./theatreDetail.vue?vue&type=style&index=1&id=60dde580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dde580",
  null
  
)

export default component.exports